import { FinanceValueObjectsAccountTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const ledgerAccountTypeLabel = (type: FinanceValueObjectsAccountTypeEnum) =>
  ({
    ['bank']: i18n.t('finance.chart_of_accounts.types.bank'),
    ['current_asset']: i18n.t('finance.chart_of_accounts.types.current_asset'),
    ['current_liability']: i18n.t('finance.chart_of_accounts.types.current_liability'),
    ['equity']: i18n.t('finance.chart_of_accounts.types.equity'),
    ['expense']: i18n.t('finance.chart_of_accounts.types.expense'),
    ['income']: i18n.t('finance.chart_of_accounts.types.income'),
    ['non_current_asset']: i18n.t('finance.chart_of_accounts.types.non_current_asset'),
    ['non_current_liability']: i18n.t('finance.chart_of_accounts.types.non_current_liability'),
  })[type] ?? ''
